// 统一引入api模块
import Task from './apiUrl/task/task'
import subsonic from './apiUrl/subsonic'
import dlna from './apiUrl/dlna'    
import agents from './apiUrl/agents'
import scriptMgmt from './apiUrl/script_mgmt'
export default {
    Task, subsonic, dlna, agents, scriptMgmt
}
